import React from "react";

import ZoningDetails from "components/projects/zoning/Details";

export const Issued = () => <ZoningDetails compact />;

// Don't allow this to fallback to the default disabled text field
export const Disabled = null;
export default () => null;
